import { ErrorHandler, makeEnvironmentProviders } from "@angular/core"

import { GlobalErrorHandler } from "@/core/error"

export function provideErrorHandling() {
    const providers = [
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandler,
        },

    ]
    return makeEnvironmentProviders([...providers])
}